import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Icon from "@/components/Icon";
import QRPreview from "@/components/QRPreview";
import DesignStudio from "@/components/DesignStudio";
import { DEFAULT_DESIGN } from "@/lib/qr";
import api from "@/lib/api";

export default function Templates() {
  const { can } = useAuth();
  const [presets, setPresets] = useState([]);
  const [design, setDesign] = useState({ ...DEFAULT_DESIGN });
  const load = () => api.get("/presets").then(({ data }) => setPresets(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async () => { const name = prompt("Template name"); if (!name) return; try { await api.post("/presets", { name, design }); toast.success("Template saved"); load(); } catch { toast.error("Could not save"); } };
  const del = async (id) => { try { await api.delete(`/presets/${id}`); load(); } catch {} };

  return (
    <AppLayout>
      <h1 className="text-2xl font-display font-extrabold mb-1">Templates & presets</h1>
      <p className="text-sm text-muted-foreground mb-6">Save company design templates and reuse them across every QR code.</p>
      <div className="grid lg:grid-cols-[400px_1fr] gap-6">
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="rounded-xl bg-white p-4 grid place-items-center mb-4"><div style={{ width: 220 }}><QRPreview design={design} data="https://qrcodecreatorstudio.com" /></div></div>
          <DesignStudio design={design} onChange={setDesign} onSavePreset={can("assets.manage") ? save : undefined} presets={presets} />
        </div>
        <div>
          <h3 className="font-display font-bold mb-3">Saved company templates</h3>
          {presets.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-border py-16 text-center text-sm text-muted-foreground">No templates yet. Design one and click "Save preset".</div>
          ) : (
            <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
              {presets.map((p) => (
                <div key={p.id} data-testid={`template-${p.id}`} className="rounded-2xl border border-border bg-card p-4">
                  <div className="rounded-xl bg-white p-2 grid place-items-center"><div style={{ width: 120 }}><QRPreview design={{ ...DEFAULT_DESIGN, ...p.design, frame: "none" }} data="https://qrcodecreatorstudio.com" frameless /></div></div>
                  <div className="flex items-center justify-between mt-3"><span className="text-sm font-semibold truncate">{p.name}</span><div className="flex gap-1"><button onClick={() => setDesign({ ...DEFAULT_DESIGN, ...p.design })} className="h-7 w-7 grid place-items-center rounded-lg hover:bg-accent" title="Load"><Icon name="Download" className="h-3.5 w-3.5" /></button>{can("assets.manage") && <button data-testid={`template-delete-${p.id}`} onClick={() => del(p.id)} className="h-7 w-7 grid place-items-center rounded-lg hover:bg-destructive/10 hover:text-destructive"><Icon name="Trash2" className="h-3.5 w-3.5" /></button>}</div></div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  );
}
